import React from "react";
import Base from "../components/Base";
import Animation from "../utils/Animation";
import Info from "../components/Info";
import Solutions from "../components/Solutiions";
import About from "../components/About";
import Contact from "../components/Contact";

const Home = () => {
  return (
    <Base
      title="Delivering IT security excellence with innovative solutions that Protect, Empower, and Drive Growth for Industries Worldwide."
      buttonEnabled={true}
      buttonText="Book a free consultation &rarr;"
      description={
        <Animation
          statement1={"Protect Sensitive Data"}
          statement2={"Secure Your Enterprise"}
          statement3={"Empower Your WorkForce"}
        />
      }
    >
      <div style={{ padding: "10px" }}>
        <Info />
      </div>
      <div style={{ padding: "10px" }}>
        <Solutions />
      </div>
      <div style={{ padding: "10px" }}>
        <About />
      </div>
      <div style={{ padding: "10px" }}>
        <Contact />
      </div>
    </Base>
  );
};

export default Home;
